import styled from "styled-components";

import { colors } from "@/styles/Variants";

const color = colors.bild;

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  & > :first-child {
    margin-right: 2px;
  }
  & > :nth-child(2) {
    margin-left: 2px;
  }
`;

export const PageIndicator = styled.div<{ $active: boolean }>`
  background-color: ${(props) =>
    props.$active ? color.red500 : color.vader100};
  padding: 2px;
  transition:
    background-color 200ms,
    color 300ms;
  flex-grow: 1;
`;
